import { computed, defineComponent, onMounted, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { AccountAction, AccountGetter } from '@/store/account/account.module';
import { Account } from '@/store/account/account.model';
import { Role } from '@/store/role/role.model';
import { Assignment } from '@/store/assignment/assignment.model';
import { AssignmentAction, AssignmentGetter } from '@/store/assignment/assignment.module';
import { FiscalYearAction, FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { RegionAction, RegionGetter } from '@/store/region/region.module';
import { Region } from '@/store/region/region.model';
import VueSelect from 'vue-select';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'MinisterFilterComponent',
  components: {
    VueSelect,
    LoadingComponent,
  },
  emits: [
    'change'
  ],
  setup(_props, context) {
    const store = useStore();
    const account = computed<Account>(() => store.getters[AccountGetter.ACCOUNT]);
    const role = computed<Role | undefined>(() => store.getters[AccountGetter.SINGLE_ROLE]);
    const assignment = computed<Assignment | undefined>(() => store.getters[AssignmentGetter.BY_ID](account.value?.id));
    const isOrs = computed<boolean>(() => store.getters[AccountGetter.IS_ROLE]('เจ้าหน้าที่ ส.กกภ.'));
    const assigned = computed(() => isOrs.value || !!assignment.value);
    const fiscalYears = computed<FiscalYear[]>(() => (store.getters[FiscalYearGetter.ALL] as FiscalYear[]).filter((m) => m.status <= 0));
    const regions = computed<Region[]>(() => {
      const all = store.getters[RegionGetter.ALL] as Region[];
      return all.filter(m => m.id !== 1);
    });
    const isLoading = computed(() => !isOrs.value && (store.getters[AssignmentGetter.STATUS] === 'init' || store.getters[AssignmentGetter.STATUS] === 'loading'));
    const filteredRegions = computed<Array<{ id: number; name: string; }>>(() => isOrs.value
      ? regions.value.filter(m => m.id != 1).map(m => ({ id: m.id, name: m.name }))
      : regions.value.filter(m => m.id != 1 && assignment.value?.assignments.some(x => x.id === m.id))
        .map(m => ({ id: m.id, name: m.name })));

    const selected = reactive({
      fiscalYearId: null as (number | null | undefined),
      regionId: null as (number | null | undefined),
    });

    onMounted(() => {
      store.dispatch(AccountAction.GET)
        .then(() => store.dispatch(FiscalYearAction.FETCH)
          .then(() => {
            selected.fiscalYearId = fiscalYears.value[0].id;
            store.dispatch(RegionAction.FETCH)
              .then(() => fiscalYearChange());

            if (role.value?.name === 'ผู้แทน ร.นรม./รมต.นร') {
              store.dispatch(AssignmentAction.FIND, { mode: 'MINISTER', id: account.value?.id });
            }
          }));
    });

    watch(() => [selected.fiscalYearId, selected.regionId], ([fiscalYearId, regionId]) => {
      context.emit('change', {
        fiscalYearId: fiscalYearId,
        regionId: regionId,
      });
    });

    const fiscalYearChange = () => {
      selected.regionId = filteredRegions.value[0].id;
    };

    return {
      role,
      fiscalYears,
      filteredRegions,
      selected,
      assigned,
      isLoading,
      fiscalYearChange,
    };
  },
});
